import { getUserName } from '../..'
import { DEFAULT_ANALYTICS_PAGE_CATEGORY } from '../analytics'
import {
  AnalyticsIdentifyProperties,
  AnalyticsPageProperties,
  AnalyticsTrackProperties,
} from '../analyticsTypes'

export const transformPosthogIdentifyProperties = (
  properties: AnalyticsIdentifyProperties
) => {
  return {
    userId: properties?.user?.id,
    traits: {
      email: properties?.user?.email,
      name: getUserName(properties?.user),
      company: {
        id: properties?.builder?.id,
        name: properties?.builder?.company?.name,
        subscription: properties?.builder?.subscription,
      },
      roles: properties?.userRoles,
      modules: properties?.modules,
    },
  }
}

export const transformPosthogGroupUserProperties = (
  properties: AnalyticsIdentifyProperties
) => {
  return {
    name: properties?.builder?.company?.name,
    subscription: properties?.builder?.subscription,
    modules: properties?.modules,
  }
}

export const transformPosthogPageProperties = (
  pageName: string,
  properties?: AnalyticsPageProperties
) => {
  return {
    name: pageName,
    properties: {
      category: properties?.category || DEFAULT_ANALYTICS_PAGE_CATEGORY,
    },
  }
}

export const transformPosthogTrackProperties = (
  eventName: string,
  properties?: AnalyticsTrackProperties
) => {
  return {
    event: eventName,
    properties: properties,
  }
}
